<template>
    <div>
        <b-card class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 class="modal-title">{{ isKonfirmasi ? 'Konfirmasi' : '' }} Inventory Pendukung</h5>
            </b-card-header>
            <b-card-body v-if="isKonfirmasi">
                <p>Penambahan inventory pendukung {{ form.name }}{{ form.gudang ? ' pada ' + form.gudang.name : '' }}.</p>
                <p>Sejumlah {{ formatNumberStrict(parseInt(form.stock)) }}.</p>
            </b-card-body>
            <b-card-body v-show="!isKonfirmasi">
                <div class="form-group">
                    <label>Nama</label>
                    <input v-validate="'required'" v-model="form.name" type="text" name="name" class="form-control">
                    <span class="text-danger">{{ errors.first('name') }}</span>
                </div>

                <div class="form-group" v-if="!gudang">
                    <label class="form-control-label">Gudang</label>
                    <div class="input-group mb-0 d-flex">
                        <multiselect :class="'w-auto flex-grow-1'" v-validate="'required'" name="gudang" v-model="form.gudang" :options="gudangOptions" :placeholder="'Pilih gudang'" :searchable="true"
                            label="name" track-by="id" :allowEmpty="false" :show-labels="false"></multiselect>
                        <div class="input-group-append">
                            <button class="btn btn-primary" type="button" @click="selectGudang = true"><i class="fas fa-search"></i> Pilih</button>
                        </div>
                    </div>
                    <span class="text-danger">{{ errors.first('gudang') }}</span>
                </div>

                <div class="form-group">
                    <label>Stock</label>
                    <input v-validate="'required|min:0'" min="0" v-model="form.stock" type="number" name="stock" class="form-control">
                    <span class="text-danger">{{ errors.first('stock') }}</span>
                </div>

                <div class="form-group">
                    <label>Stock Minimal</label>
                    <input v-validate="'required|min:0'" min="0" v-model="form.stock_minimal" type="number" name="stock_minimal" class="form-control">
                    <span class="text-danger">{{ errors.first('stock_minimal') }}</span>
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <template v-if="isKonfirmasi">
                    <button :disabled="isLoading" @click="koreksi" type="button" class="btn btn-secondary">Koreksi</button>
                    <button :disabled="isLoading" @click="save" type="button" class="btn btn-primary mr-2">OK</button>
                </template>
                <template v-else>
                    <button :disabled="isLoading" @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">Batal</button>
                    <button :disabled="isLoading" @click="konfirmasi" type="button" class="btn btn-primary mr-2">Simpan</button>
                </template>
            </b-card-footer>
        </b-card>

        <b-modal v-model="selectGudang" size="lg" :hide-header="true" :hide-footer="true">
            <gudang-selector :selected="gudangOptions" @selected="gudangSelected" @cancel="selectGudang = false"></gudang-selector>
        </b-modal>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import GudangSelector from '../gudangs/Selector';

export default {
    name: "inventory-pendukung-form",

    props: {
        gudang: {
            type: Object,
            default: () => {},
        },

        value: {
            type: Object,
            default: () => {},
        },
    },

    components: {
        Multiselect,
        GudangSelector,
    },

    data() {
        return {
            form: {
                name: null,
                gudang: null,
                stock: null,
                stock_minimal: null,
            },
            selectGudang: false,
            gudangOptions: [],
            isKonfirmasi: false,
        }
    },

    created() {
        this.resetForm();
    },

    mounted() {
        this.resetForm();
    },

    computed: {
    },

    watch: {
    },

    methods: {
        resetForm() {
            this.form = Object.assign({}, {
                name: null,
                gudang: this.gudang ? Object.assign({}, this.gudang) : null,
                stock: null,
                stock_minimal: null,
            });

            if (this.value) {
                this.form.name = this.value.name;
                this.form.gudang = Object.assign({}, this.value.gudang);
                this.form.stock = this.value.stock;
                this.form.stock_minimal = this.value.stock_minimal;
            }
        },

        konfirmasi() {
            let self = this;

            if (self.value) {
                self.save();
                return;
            }

            self.$validator.validateAll().then(result => {
                if (result) {
                    self.isKonfirmasi = true;
                }
            });
        },

        koreksi() {
            this.isKonfirmasi = false;
        },

        save() {
            let self = this;

            self.isLoading = true;

            let data = {
                name: self.form.name,
                gudang_id: self.form.gudang ? self.form.gudang.id : null,
                stock: self.form.stock,
                stock_minimal: self.form.stock_minimal,
            }

            let api = self.value ? '/api/inventory-pendukungs/'+self.value.id : '/api/inventory-pendukungs';

            self.$Progress.start();
            axios({
                method: self.value ? 'put' : 'post',
                url: api,
                data: data,
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.isLoading = false;
                self.$Progress.finish();
                self.$emit('saved', response.data.data);
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },

        gudangSelected(gudang) {
            let self = this;

            self.gudangOptions.push(gudang);
            self.form.gudang = Object.assign({}, gudang);
            self.selectGudang = false;
        },
    },
}
</script>
